/**
 * @constructor
 * @implements {Foundation.View.Interface.ErrorList}
 * @extends {Foundation.Promise}
 * @param {jQuerySelector} viewContainer
 */
Foundation.View.Desktop.ErrorList = function (viewContainer) {
    Foundation.Promise.call(this);
    
    /** @type {jQuery} */
    this.view = jQuery(viewContainer);
    if (this.view[0]) {
        this.fulfill();
    }
    else {
        this.fail();
    }
    
    this.clear();
};
Foundation.inherit(Foundation.View.Desktop.ErrorList, Foundation.Promise);

Foundation.View.Desktop.ErrorList.prototype.clear = function () {
    this.view.hide().find("ol li").remove();
};

Foundation.View.Desktop.ErrorList.prototype.setErrorsFromObservable = function (obj) {
    this.clear();
    
    var errorArray = obj.get("errors") || [];
    if (errorArray.length) {
        var list = this.view.find("ol");
        for (var i = 0; i < errorArray.length; i++) {
            var message = Foundation.isString(errorArray[i])
                              ? errorArray[i] 
                              : errorArray[i]["message"];
            var listItem = jQuery("<li>").html(message);
            list.append(listItem);
        }
        this.view.fadeIn(300);
    }
};

